module.exports = __webpack_public_path__ + "img/logo.fa6e0804.png";